import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getStoreDetail,
  getStoreTimes,
  updateStoreTimes,
} from "../../redux/actions/storeActions";
import DefaultLayout from "../../layouts/DefaultLayout";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import { baseURLFile } from "../../constants";
import { toast } from "react-toastify";

function StoreTimeScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  //
  //   #     (0, "Monday"),
  const [startMonday, setStartMonday] = useState("");
  const [startMondayError, setStartMondayError] = useState("");

  const [endMonday, setEndMonday] = useState("");
  const [endMondayError, setEndMondayError] = useState("");

  const [isMondayClosed, setIsMondayClosed] = useState(true);
  //   #     (1, "Tuesday"),
  const [startTuesday, setStartTuesday] = useState("");
  const [startTuesdayError, setStartTuesdayError] = useState("");

  const [endTuesday, setEndTuesday] = useState("");
  const [endTuesdayError, setEndTuesdayError] = useState("");

  const [isTuesdayClosed, setIsTuesdayClosed] = useState(true);
  //   #     (2, "Wednesday"),
  const [startWednesday, setStartWednesday] = useState("");
  const [startWednesdayError, setStartWednesdayError] = useState("");

  const [endWednesday, setEndWednesday] = useState("");
  const [endWednesdayError, setEndWednesdayError] = useState("");

  const [isWednesdayClosed, setIsWednesdayClosed] = useState(true);
  //   #     (3, "Thursday"),
  const [startThursday, setStartThursday] = useState("");
  const [startThursdayError, setStartThursdayError] = useState("");

  const [endThursday, setEndThursday] = useState("");
  const [endThursdayError, setEndThursdayError] = useState("");

  const [isThursdayClosed, setIsThursdayClosed] = useState(true);
  //   #     (4, "Friday"),
  const [startFriday, setStartFriday] = useState("");
  const [startFridayError, setStartFridayError] = useState("");

  const [endFriday, setEndFriday] = useState("");
  const [endFridayError, setEndFridayError] = useState("");

  const [isFridayClosed, setIsFridayClosed] = useState(true);
  //   #     (5, "Saturday"),
  const [startSaturday, setStartSaturday] = useState("");
  const [startSaturdayError, setStartSaturdayError] = useState("");

  const [endSaturday, setEndSaturday] = useState("");
  const [endSaturdayError, setEndSaturdayError] = useState("");

  const [isSaturdayClosed, setIsSaturdayClosed] = useState(true);
  //   #     (6, "Sunday"),
  const [startSunday, setStartSunday] = useState("");
  const [startSundayError, setStartSundayError] = useState("");

  const [endSunday, setEndSunday] = useState("");
  const [endSundayError, setEndSundayError] = useState("");

  const [isSundayClosed, setIsSundayClosed] = useState(true);

  //
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const storeDetail = useSelector((state) => state.detailStore);
  const { loadingStoreInfo, errorStoreInfo, successStoreInfo, storeInfo } =
    storeDetail;

  const storeTime = useSelector((state) => state.getListTimesStore);
  const { loadingTimesStore, errorTimesStore, storeTimes } = storeTime;

  const storeUpdateTimes = useSelector((state) => state.updateStoreTimes);
  const {
    loadingStoreUpdateTime,
    errorStoreUpdateTime,
    successStoreUpdateTime,
  } = storeUpdateTimes;

  const redirect = "/";
  useEffect(() => {
    const fetchData = async () => {
      if (!userInfo) {
        navigate(redirect);
      } else {
        // await dispatch(getListStoresUsers("0"));
        await dispatch(getStoreTimes(id));
        await dispatch(getStoreDetail(id));
      }
    };

    fetchData();
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (storeInfo && storeInfo !== null && storeInfo !== undefined) {
      for (let index = 0; index < storeTimes?.length; index++) {
        const element = storeTimes[index];

        //         #     (0, "Monday"),
        if (element.name_day === "Monday") {
          if (element.is_closed) {
            setIsMondayClosed(true);
            setStartMonday("");
            setEndMonday("");
          } else {
            setIsMondayClosed(false);
            setStartMonday(element.time_start ?? "");
            setEndMonday(element.time_end ?? "");
          }
        }
        // #     (1, "Tuesday"),
        else if (element.name_day === "Tuesday") {
          if (element.is_closed) {
            setIsTuesdayClosed(true);
            setStartTuesday("");
            setEndTuesday("");
          } else {
            setIsTuesdayClosed(false);
            setStartTuesday(element.time_start ?? "");
            setEndTuesday(element.time_end ?? "");
          }
        }
        // #     (2, "Wednesday"),
        else if (element.name_day === "Wednesday") {
          if (element.is_closed) {
            setIsWednesdayClosed(true);
            setStartWednesday("");
            setEndWednesday("");
          } else {
            setIsWednesdayClosed(false);
            setStartWednesday(element.time_start ?? "");
            setEndWednesday(element.time_end ?? "");
          }
        }
        // #     (3, "Thursday"),
        else if (element.name_day === "Thursday") {
          if (element.is_closed) {
            setIsThursdayClosed(true);
            setStartThursday("");
            setEndThursday("");
          } else {
            setIsThursdayClosed(false);
            setStartThursday(element.time_start ?? "");
            setEndThursday(element.time_end ?? "");
          }
        }
        // #     (4, "Friday"),
        else if (element.name_day === "Friday") {
          if (element.is_closed) {
            setIsFridayClosed(true);
            setStartFriday("");
            setEndFriday("");
          } else {
            setIsFridayClosed(false);
            setStartFriday(element.time_start ?? "");
            setEndFriday(element.time_end ?? "");
          }
        }
        // #     (5, "Saturday"),
        else if (element.name_day === "Saturday") {
          if (element.is_closed) {
            setIsSaturdayClosed(true);
            setStartSaturday("");
            setEndSaturday("");
          } else {
            setIsSaturdayClosed(false);
            setStartSaturday(element.time_start ?? "");
            setEndSaturday(element.time_end ?? "");
          }
        }
        // #     (6, "Sunday"),
        else if (element.name_day === "Sunday") {
          if (element.is_closed) {
            setIsSundayClosed(true);
            setStartSunday("");
            setEndSunday("");
          } else {
            setIsSundayClosed(false);
            setStartSunday(element.time_start ?? "");
            setEndSunday(element.time_end ?? "");
          }
        }
      }
    }
  }, [storeInfo]);
  return (
    <DefaultLayout>
      <div>
        <div className="flex flex-row text-sm items-center my-1">
          {/* home */}
          <a href="/dashboard">
            <div className="flex flex-row  items-center hover:text-black ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div className="">Store Times</div>
        </div>
        {/*  */}
        <div className="flex flex-row justify-between  items-center my-3">
          <div className="mx-1 font-bold text-black ">Store Times</div>
        </div>
        {/*  */}
        {loadingStoreInfo ? (
          <Loader />
        ) : errorStoreInfo ? (
          <Alert message={errorStoreInfo} />
        ) : storeInfo ? (
          <div>
            <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default my-1  ">
              <div className="container mx-auto flex flex-col">
                <div className="flex md:flex-row  items-center">
                  <div className="mx-3">
                    <div className="my-1 px-2 py-1">
                      <img
                        src={baseURLFile + storeInfo.store_logo}
                        className="size-15 rounded border-white border"
                      />
                    </div>
                  </div>
                  <div className="flex-1 w-full">
                    <div className="my-1">
                      Store Name:{" "}
                      <span className="font-bold">
                        {storeInfo.store_name ?? "---"}
                      </span>
                    </div>
                    <div className="my-1">
                      Store Type:{" "}
                      <span className="font-bold">
                        {storeInfo.store_type ?? "---"}
                      </span>
                    </div>
                  </div>
                </div>
                {/* time */}
              </div>
            </div>
            {/*  */}
            <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default  mt-3 ">
              <div className="container mx-auto flex flex-col">
                {/* Monday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Monday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="monday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isMondayClosed}
                          onChange={(v) => setIsMondayClosed(!isMondayClosed)}
                        />
                        <label
                          for="monday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isMondayClosed}
                          className={` outline-none border ${
                            startMondayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startMonday}
                          onChange={(v) => setStartMonday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startMondayError ? startMondayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isMondayClosed}
                          className={` outline-none border ${
                            endMondayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endMonday}
                          onChange={(v) => setEndMonday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endMondayError ? endMondayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/* Tuesday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Tuesday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="tuesday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isTuesdayClosed}
                          onChange={(v) => setIsTuesdayClosed(!isTuesdayClosed)}
                        />
                        <label
                          for="tuesday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isTuesdayClosed}
                          className={` outline-none border ${
                            startTuesdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startTuesday}
                          onChange={(v) => setStartTuesday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startTuesdayError ? startTuesdayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isTuesdayClosed}
                          className={` outline-none border ${
                            endTuesdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endTuesday}
                          onChange={(v) => setEndTuesday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endTuesdayError ? endTuesdayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/* Wednesday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Wednesday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="wednesday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isWednesdayClosed}
                          onChange={(v) =>
                            setIsWednesdayClosed(!isWednesdayClosed)
                          }
                        />
                        <label
                          for="wednesday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isWednesdayClosed}
                          className={` outline-none border ${
                            startWednesdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startWednesday}
                          onChange={(v) => setStartWednesday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startWednesdayError ? startWednesdayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isWednesdayClosed}
                          className={` outline-none border ${
                            endWednesdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endWednesday}
                          onChange={(v) => setEndWednesday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endWednesdayError ? endWednesdayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/* Thursday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Thursday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="thursday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isThursdayClosed}
                          onChange={(v) =>
                            setIsThursdayClosed(!isThursdayClosed)
                          }
                        />
                        <label
                          for="thursday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isThursdayClosed}
                          className={` outline-none border ${
                            startThursdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startThursday}
                          onChange={(v) => setStartThursday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startThursdayError ? startThursdayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isThursdayClosed}
                          className={` outline-none border ${
                            endThursdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endThursday}
                          onChange={(v) => setEndThursday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endThursdayError ? endThursdayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/* Friday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Friday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="friday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isFridayClosed}
                          onChange={(v) => setIsFridayClosed(!isFridayClosed)}
                        />
                        <label
                          for="friday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isFridayClosed}
                          className={` outline-none border ${
                            startFridayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startFriday}
                          onChange={(v) => setStartFriday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startFridayError ? startFridayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isFridayClosed}
                          className={` outline-none border ${
                            endFridayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endFriday}
                          onChange={(v) => setEndFriday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endFridayError ? endFridayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/* Saturday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Saturday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="saturday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isSaturdayClosed}
                          onChange={(v) =>
                            setIsSaturdayClosed(!isSaturdayClosed)
                          }
                        />
                        <label
                          for="saturday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isSaturdayClosed}
                          className={` outline-none border ${
                            startSaturdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startSaturday}
                          onChange={(v) => setStartSaturday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startSaturdayError ? startSaturdayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isSaturdayClosed}
                          className={` outline-none border ${
                            endSaturdayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endSaturday}
                          onChange={(v) => setEndSaturday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endSaturdayError ? endSaturdayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/* Sunday */}
                <fieldset className="border rounded px-2 py-2 my-2">
                  <legend className="text-black text-sm px-2">Sunday</legend>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="flex flex-row">
                        <input
                          id="sunday-closed"
                          className={`cursor-pointer outline-none border  px-3 py-2 rounded text-sm`}
                          type={"checkbox"}
                          checked={isSundayClosed}
                          onChange={(v) => setIsSundayClosed(!isSundayClosed)}
                        />
                        <label
                          for="sunday-closed"
                          className=" cursor-pointer mx-2 font-bold text-black text-sm my-1"
                        >
                          Is Closed
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex md:flex-row flex-col  ">
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Open Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isSundayClosed}
                          className={` outline-none border ${
                            startSundayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Open Time"
                          value={startSunday}
                          onChange={(v) => setStartSunday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {startSundayError ? startSundayError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="md:w-1/2 w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Close Time <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          disabled={isSundayClosed}
                          className={` outline-none border ${
                            endSundayError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type={"time"}
                          placeholder="Close Time"
                          value={endSunday}
                          onChange={(v) => setEndSunday(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {endSundayError ? endSundayError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                {/*  */}
                <div className="my-3 ">
                  <div className="flex flex-row items-center justify-end my-3">
                    <a
                      href="/stores"
                      className="bg-white text-[#0388A6] text-sm px-5 py-3 rounded-full mr-3"
                    >
                      Back
                    </a>
                    <button
                      disabled={loadingStoreUpdateTime}
                      onClick={async () => {
                        var check = true;
                        // #     (0, "Monday"),
                        setStartMondayError("");
                        setEndMondayError("");
                        // #     (1, "Tuesday"),
                        setStartTuesdayError("");
                        setEndTuesdayError("");
                        // #     (2, "Wednesday"),
                        setStartWednesdayError("");
                        setEndWednesdayError("");
                        // #     (3, "Thursday"),

                        setStartThursdayError("");
                        setEndThursdayError("");
                        // #     (4, "Friday"),

                        setStartFridayError("");
                        setEndFridayError("");
                        // #     (5, "Saturday"),

                        setStartSaturdayError("");
                        setEndSaturdayError("");
                        // #     (6, "Sunday"),

                        setStartSundayError("");
                        setEndSundayError("");
                        //
                        if (isMondayClosed === false) {
                          if (startMonday === "") {
                            setStartMondayError("These fields are required.");
                            check = false;
                          }
                          if (endMonday === "") {
                            setEndMondayError("These fields are required.");
                            check = false;
                          }
                        }
                        if (isTuesdayClosed === false) {
                          if (startTuesday === "") {
                            setStartTuesdayError("These fields are required.");
                            check = false;
                          }
                          if (endTuesday === "") {
                            setEndTuesdayError("These fields are required.");
                            check = false;
                          }
                        }
                        if (isWednesdayClosed === false) {
                          if (startWednesday === "") {
                            setStartWednesdayError(
                              "These fields are required."
                            );
                            check = false;
                          }
                          if (endWednesday === "") {
                            setEndWednesdayError("These fields are required.");
                            check = false;
                          }
                        }
                        if (isThursdayClosed === false) {
                          if (startThursday === "") {
                            setStartThursdayError("These fields are required.");
                            check = false;
                          }
                          if (endThursday === "") {
                            setEndThursdayError("These fields are required.");
                            check = false;
                          }
                        }
                        if (isFridayClosed === false) {
                          if (startFriday === "") {
                            setStartFridayError("These fields are required.");
                            check = false;
                          }
                          if (endFriday === "") {
                            setEndFridayError("These fields are required.");
                            check = false;
                          }
                        }
                        if (isSaturdayClosed === false) {
                          if (startSaturday === "") {
                            setStartSaturdayError("These fields are required.");
                            check = false;
                          }
                          if (endSaturday === "") {
                            setEndSaturdayError("These fields are required.");
                            check = false;
                          }
                        }
                        if (isSundayClosed === false) {
                          if (startSunday === "") {
                            setStartSundayError("These fields are required.");
                            check = false;
                          }
                          if (endSunday === "") {
                            setEndSundayError("These fields are required.");
                            check = false;
                          }
                        }

                        if (check) {
                          // setLoadEvent(true);
                          await dispatch(
                            updateStoreTimes(id, {
                              // #     (0, "Monday"),
                              is_monday: isMondayClosed ? "True" : "False",
                              start_monday: isMondayClosed ? "" : startMonday,
                              end_monday: isMondayClosed ? "" : endMonday,
                              // #     (1, "Tuesday"),
                              is_tuesday: isTuesdayClosed ? "True" : "False",
                              start_tuesday: isTuesdayClosed
                                ? ""
                                : startTuesday,
                              end_tuesday: isTuesdayClosed ? "" : endTuesday,
                              // #     (2, "Wednesday"),
                              is_wednesday: isWednesdayClosed
                                ? "True"
                                : "False",
                              start_wednesday: isWednesdayClosed
                                ? ""
                                : startWednesday,
                              end_wednesday: isWednesdayClosed
                                ? ""
                                : endWednesday,
                              // #     (3, "Thursday"),
                              is_thursday: isThursdayClosed ? "True" : "False",
                              start_thursday: isThursdayClosed
                                ? ""
                                : startThursday,
                              end_thursday: isThursdayClosed ? "" : endThursday,
                              // #     (4, "Friday"),
                              is_friday: isFridayClosed ? "True" : "False",
                              start_friday: isFridayClosed ? "" : startFriday,
                              end_friday: isFridayClosed ? "" : endFriday,
                              // #     (5, "Saturday"),
                              is_saturday: isSaturdayClosed ? "True" : "False",
                              start_saturday: isSaturdayClosed
                                ? ""
                                : startSaturday,
                              end_saturday: isSaturdayClosed ? "" : endSaturday,
                              // #     (6, "Sunday"),
                              is_sunday: isSundayClosed ? "True" : "False",
                              start_sunday: isSundayClosed ? "" : startSunday,
                              end_sunday: isSundayClosed ? "" : endSunday,
                            })
                          ).then(() => {});
                          // setLoadEvent(false);
                        } else {
                          toast.error(
                            "Some fields are empty or invalid. please try again"
                          );
                        }
                      }}
                      className="text-white bg-[#0388A6] text-sm px-5 py-3 rounded-full"
                    >
                      {loadingStoreUpdateTime
                        ? "Loading ..."
                        : "Edit Store Times"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </DefaultLayout>
  );
}

export default StoreTimeScreen;
